import React, { useState, useEffect, useContext } from 'react'
import { Redirect } from 'react-router-dom';


import Heading2 from '../../../elements/titles/Heading2'
import Heading3 from '../../../elements/titles/Heading3'
import Paragraph from '../../../elements/p/Paragraph'
import Container from '../../../utils/Container'
import Loader from '../../../utils/Loader'
import LoaderCircle from '../../../utils/LoaderCircle'
import Button from '../../../elements/buttons/Button'
import AdminAside from './AdminAside'

import { AiOutlineDelete, AiFillFilePdf } from 'react-icons/ai';
import { GrSave } from 'react-icons/gr';

import { getContacts, deleteContact, registerContact } from "../../../../api/contacts/index"
import contactsContext from "../../../../dataManager/contactsContext"

const AdminContent = () => {

    const [loading, setLoading] = useState(false)
    const [displayAllContacts, setDisplayAllContacts] = useState(true)

    const { contacts, saveAllContacts } = useContext(contactsContext)

    useEffect(() => {
        getContacts(saveAllContacts)
    }, [])

    const handleDelete = async (event, id) => {

        event.stopPropagation()

        setLoading(true)

        try{
            const result = await deleteContact(id)
            console.log(result)
        }catch(err){
            console.log(err)
        }finally{
            setLoading(false)
        }
    }

    const handleSave = async (event, id) => {

        event.stopPropagation()

        setLoading(true)

        try{
            const result = await registerContact(id)
            console.log(result)
        }catch(err){
            console.log(err)
        }finally{
            setLoading(false)
        }
    }

    // display all contacts or register contacts
    const contactsElts = () => {

        const contactsDivs = contacts.length ? contacts.map(contact => {

          if(displayAllContacts){
              return (
                    <ContactCard
                        key={contact.id}
                        id={contact.id}
                        firstName={ contact.firstName }
                        lastName={ contact.lastName }
                        subject={ contact.subject }
                        message={ contact.message }
                        file={contact.file}
                        onDelete={ handleDelete }
                        onSave={ handleSave }
                    />
                )
          }else{
            return contact.isRegister && (
                    <ContactCard
                        key={contact.id}
                        id={contact.id}
                        firstName={ contact.firstName }
                        lastName={ contact.lastName }
                        subject={ contact.subject }
                        message={ contact.message }
                        file={contact.file}
                        onDelete={ handleDelete }
                        onSave={ handleSave }
                    />
                )
          }

        }) : <LoaderCircle color="#F35899" position="absolute" size="large" />

        return contactsDivs

    }

    return (
        <Container classe="mt-40">
            <Heading2 color="secondary" classe="uppercase">
                interface d'administration - rita nsangou
            </Heading2>

            <div className="adminContainer relative mr-10 mt-5">
                <AdminAside contacts={contacts} />

                <main className={`${ loading && "opacity-40" } mainAdmin relative flex flex-col space-y-3 ml-3 md:pr-3`}>
                    <ul className="flex space-x-5 items-center mb-1">
                        <li 
                            className={`${ displayAllContacts && "p-2 bg-primary text-white rounded" } cursor-pointer uppercase text-sm md:text-medium letter-spacing-3 font-primary text-gray-700`}
                            onClick={ () => setDisplayAllContacts(prevState => !prevState) }>
                            
                            Tous les Contacts
                        </li>
                        <li 
                            className={`${ !displayAllContacts && "p-2 bg-primary text-white rounded" } cursor-pointer uppercase text-sm md:text-medium letter-spacing-3 font-primary text-gray-700`}
                            onClick={ () => setDisplayAllContacts(prevState => !prevState) }>
                            Contacts Enregistrés
                        </li>
                    </ul>

                    <div className="flex flex-col space-y-3">
                        { contactsElts() }
                    </div>

                    {
                        loading && <LoaderCircle color="#F35899" position="absolute" size="large" />
                    }
                </main>
            </div>
            
        </Container>
    )
}

const ContactCard = (props) => {

    const { id, firstName, lastName, subject, message, file, onDelete, onSave } = props

    const [detailContact, setDetailContact] = useState(false)


    const handleDetail = (event) => {
        setDetailContact(true)
    }

    return(
        <article 
            className="relative w-full bg-custom-gray p-4 rounded-md cursor-pointer hover:opacity-80"
            onClick={handleDetail}
        > 
             <header className="flex justify-between items-center">
                 <span className="font-bold text-secondary">{`${firstName.toUpperCase()} ${lastName.toLowerCase()}`}</span>
                 <div className="flex space-x-5 items-center">
                    <GrSave 
                        size="20" 
                        color="#F35899" 
                        title="Enregistrez ce contact" 
                        className="cursor-pointer"
                        onClick={ (event) => onSave(event, id)  }
                    />
                    <div>
                        <AiOutlineDelete 
                            size="20" 
                            color="#F35899" 
                            title="Supprimer ce contact" 
                            className="cursor-pointer"
                            onClick={ (event) => onDelete(event, id) }
                        />
                    </div>
                 </div>
             </header>
             <main className="flex justify-between items-center mt-3">
                 <div>
                    <h4 className="font-secondary font-semibold">{subject}</h4>
                    <p className="truncateText font-gray-100 mt-0.5 line-clap-2">{message}</p>
                 </div>

                 {
                    !file ? <p className="hidden sm:block uppercase text-sm text-gray-700"> no file</p> : (
                        <a href={file} download target="_blanck">
                        <AiFillFilePdf size="40" color="#455A64" title="télécharger le document" className="hidden sm:block cursor-pointer" />
                     </a>)
                 }
             </main>
             { detailContact && <Redirect to={`/admin/contacts/${id}`} /> }
        </article>
    )
}

export default AdminContent